export default "__VITE_ASSET__C8g24_ek__"